module.exports = __webpack_public_path__ + "static/media/SliceRushTeaser.56552fd5.jpg";